import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'semantic-ui-react';
import HelpButton from '../HelpButton';
import VehicleState from './VehicleState';
import { CoverageVehicleFields } from './VehicleFields';
import useDebounce from '../../../../../helpers/debounce';

const VinModal = ({ open, onClose, actions, onContinue, versionId }) => {
	const [vin, setVin] = useState('');
	const debouncedVin = useDebounce(vin, 500);

	const [loading, setLoading] = useState(false);
	const [vehicle, setVehicle] = useState(null);

	useEffect(() => {
		const load = async () => {
			if (vin !== '' && vin.length === 17) {
				setLoading(true);
				try {
					const result = await actions.vehicleLookup(debouncedVin, null, null, null, versionId);
					setVehicle({ ...result.response, vin });
				} catch {
					setVehicle(null);
				}
				setLoading(false);
			}
		};

		load();

		return () => {
			setVehicle(null);
			setLoading(false);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [debouncedVin]);

	useEffect(() => {
		setVehicle(null);
	}, [vin]);

	const vehicleState = useMemo(() => {
		return { loading, valid: vehicle != null, vehicle };
	}, [loading, vehicle]);

	return (
		<Modal open={open} onClose={onClose} size='tiny'>
			<Modal.Header>VIN Required</Modal.Header>
			<Modal.Content>
				<Form>
					<Form.Group inline>
						<Form.Input
							name='vin'
							onChange={(_, { value }) => setVin(value)}
							label={
								<label>
									{CoverageVehicleFields.vin.label}
									<HelpButton>{CoverageVehicleFields.vin.help}</HelpButton>
								</label>
							}
						/>
					</Form.Group>
					<VehicleState state={vehicleState} isVin />
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button primary onClick={onClose}>
					Cancel
				</Button>
				<Button primary disabled={!vehicleState.valid} onClick={() => onContinue(vehicleState.vehicle)}>
					Continue
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

VinModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	actions: PropTypes.any.isRequired,
	onContinue: PropTypes.func.isRequired,
};

export default VinModal;
